import React, { useContext, useEffect, useState } from 'react'
import * as classes from './Apartments.module.scss'
import Container from '../../../ui/Container/Container'
import SectionTitle from '../../../ui/SectionTitle/SectionTitle'
import IconLeft from '../../../icons/IconLeft'
import { Swiper, SwiperSlide } from 'swiper/react'
import { deleteHtmlTag } from '../../../../utils/deleteHtmlTag'
import { FormContext } from './../../../../context/index'
import splitRow from '../../../../utils/splitRow'
import { startAnimationScroll } from '../../../../utils/animations'
import { useWindowSize } from '../../../../hooks/useWindowSize'

function Apartments({ data, titleSection, secondTitleSection, lang }) {
    const { animationStart } = useContext(FormContext)
    const windowSize = useWindowSize()

    const [swiperShow, setSwiperShow] = useState(false)
    const [swiper, setSwiper] = useState(null)

    const apartments = deleteHtmlTag(data.apartments, 'p')
    const sectionTitle = deleteHtmlTag(titleSection.value, 'p')
    const secondTitle = deleteHtmlTag(secondTitleSection.value, 'p')


    const gallery = windowSize.width && windowSize.width < 768 ? data.galleryMobile : data.galleryDesktop

    const classAnimationText = 'anime-text-projects-apartments'

    useEffect(() => {
        if (animationStart) {
            splitRow(classAnimationText)
            setSwiperShow(true)
        }

        const observer = startAnimationScroll([{ type: 'text', className: classAnimationText }])

        return () => {
            if (observer) {
                observer.disconnect()
            }
        }
    }, [animationStart])

    return (
        <section className={classes.Section}>
            <Container>
                {sectionTitle || (gallery && gallery.length > 1) ? (
                    <div className={classes.Header}>
                        {sectionTitle ? <SectionTitle className={classes.Title} title={sectionTitle} lang={lang} /> : null}

                        {gallery && gallery.length > 1 ? (
                            <div className={classes.Controls}>
                                <button className={classes.Prev} onClick={() => swiper && swiper.slidePrev()}>
                                    <IconLeft />
                                </button>

                                <button className={classes.Next} onClick={() => swiper && swiper.slideNext()}>
                                    <IconLeft />
                                </button>
                            </div>
                        ) : null}
                    </div>
                ) : null}
            </Container>

            {gallery && gallery.length && swiperShow ? (
                <Swiper className={classes.Slider} onSwiper={setSwiper} speed={500} slidesPerView='auto' spaceBetween={24}>
                    {gallery.map((item, index) => (
                        <SwiperSlide className={classes.Slide} key={index}>
                            <img className={classes.Image} src={item.url} alt='' />
                        </SwiperSlide>
                    ))}
                </Swiper>
            ) : null}
            <Container>
                {apartments ? (
                    <div className={classes.SecondSection}>
                        {secondTitle ? <SectionTitle title={secondTitle} lang={lang} /> : null}
                        <p className={`${classes.Desc} ${classAnimationText}`} dangerouslySetInnerHTML={{ __html: apartments }} />
                    </div>
                ) : null}
            </Container>
        </section>
    )
}

export default Apartments
